import { BaseModel } from "./hateoas/base-model";

export class RejectionManagerModel extends BaseModel {
  analyzeReportUuid?: string;
  managerUuid?: string;
  descriptionRejection?: string;
}
